import React, { useState } from 'react';
import styles from './Application.module.css';

export default function ApplicationModal({ position, onSubmit, onClose }) {
  const [coverLetter, setCoverLetter] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await onSubmit({
        positionId: position?._id,
        coverLetter: coverLetter.trim()
      });
    } catch (error) {
      console.error('Error submitting application:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!position) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.applicationModal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Apply to Position</h2>
          <button className={styles.modalClose} onClick={onClose}>×</button>
        </div>

        <div className={styles.modalContent}>
          {/* Position Info */}
          <div className={styles.positionSummary}>
            <h3>{position.title || 'Unknown Position'}</h3>
            <p>{position.institution || 'Unknown Institution'}</p>
            {position.city && position.country && (
              <p>{position.city}, {position.country}</p>
            )}
          </div>

          {/* Application Form */}
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="coverLetter" className={styles.formLabel}>
                Quick Message <span className={styles.optional}>(Optional)</span>
              </label>
              <textarea
                id="coverLetter"
                className={styles.formTextarea}
                rows={8}
                placeholder="Tell the professor why you're interested in this position and how your background aligns with their research..."
                value={coverLetter}
                onChange={(e) => setCoverLetter(e.target.value)}
                maxLength={2000}
              />
              <div className={styles.characterCount}>
                {coverLetter.length}/2000 characters
              </div>
            </div>

            <div className={styles.modalActions}>
              <button
                type="button"
                className={styles.btnSecondary}
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={styles.btnPrimary}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}